import * as React from "react"
import {FormattedDate, FormattedMessage} from "react-intl"

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faCalendarAlt} from "@fortawesome/pro-regular-svg-icons/faCalendarAlt"
import {faCreditCard} from "@fortawesome/pro-regular-svg-icons/faCreditCard"
import {faCheckCircle} from "@fortawesome/pro-solid-svg-icons/faCheckCircle"
import {faCoins} from "@fortawesome/pro-regular-svg-icons/faCoins"
import {faDoNotEnter} from "@fortawesome/pro-solid-svg-icons/faDoNotEnter"
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons/faExclamationTriangle"
import {faHandHoldingUsd} from "@fortawesome/pro-regular-svg-icons/faHandHoldingUsd"
import {faLockOpen} from "@fortawesome/pro-regular-svg-icons/faLockOpen"
import {faHandshake} from "@fortawesome/pro-regular-svg-icons/faHandshake"
import {faQuestionCircle} from "@fortawesome/pro-solid-svg-icons/faQuestionCircle"

import Tooltip from "@reach/tooltip"

import Row from "../../../components/row.js"
import Text from "../../../components/text.js"
import View from "../../../components/view.js"

import {iconFloatingStyles} from "../../../components/styled.js"

const StateMapping = {
  todo: <FontAwesomeIcon icon={faCreditCard} color="#bebebe" />,
  todo_unknown_amount: (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={faCreditCard} color="#bebebe" />
      <FontAwesomeIcon
        icon={faQuestionCircle}
        size="sm"
        color="#eb7100"
        style={iconFloatingStyles}
      />
    </span>
  ),
  done_ok: (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={faCreditCard} />
      <FontAwesomeIcon
        icon={faCheckCircle}
        size="sm"
        color="#2abb9c"
        style={iconFloatingStyles}
      />
    </span>
  ),
  done_error: (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={faCreditCard} />
      <FontAwesomeIcon
        icon={faDoNotEnter}
        size="sm"
        color="#ea0909"
        style={iconFloatingStyles}
      />
    </span>
  ),
  done_expired: (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={faCreditCard} />
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        size="sm"
        color="#c6c6c6"
        style={iconFloatingStyles}
      />
    </span>
  ),
}

const LogMapping = {
  psp_authorize: <FontAwesomeIcon icon={faLockOpen} fixedWidth size="2x" />,
  psp_enroll: <FontAwesomeIcon icon={faHandshake} fixedWidth size="2x" />,
  psp_cancel_auth: (
    <FontAwesomeIcon icon={faHandHoldingUsd} fixedWidth size="2x" />
  ),
  psp_capture: <FontAwesomeIcon icon={faCoins} fixedWidth size="2x" />,
  psp_error: (
    <FontAwesomeIcon icon={faDoNotEnter} color="#ea0909" fixedWidth size="2x" />
  ),
  psp_auth_expired: (
    <FontAwesomeIcon
      icon={faExclamationTriangle}
      color="#c6c6c6"
      fixedWidth
      size="2x"
    />
  ),
}

const BankAuthState = props => {
  const {cell} = props

  let hover = null
  if (cell?.logs?.length) {
    hover = (
      <>
        {cell.logs.map((log, index) => {
          return (
            <Row
              key={index}
              mb={index < cell.logs.length - 1 ? 3 : 0}
              alignItems="flex-start"
            >
              <View noshrink nogrow mr={2}>
                {log?.event ? (
                  LogMapping[log.event]
                ) : (
                  <FontAwesomeIcon icon={faCalendarAlt} fixedWidth />
                )}
              </View>
              <View>
                {log?.date || log?.event ? (
                  <Text>
                    {log?.event ? (
                      <FormattedMessage id={`arrivals.logs.${log.event}`} />
                    ) : null}
                    {log?.event && log?.date ? " - " : null}
                    {log?.date ? (
                      <FormattedDate
                        value={new Date(log.date)}
                        format="full-short"
                      />
                    ) : null}
                    <br />
                  </Text>
                ) : null}
                {log?.card || log?.amount ? (
                  <Text>
                    {log?.card ? log.card : null}
                    {log?.amount ? ` - ${log.amount}` : null}
                    <br />
                  </Text>
                ) : null}
                {log?.message ? <Text>{log.message}</Text> : null}
              </View>
            </Row>
          )
        })}
      </>
    )
  }

  if (hover) {
    return (
      <Tooltip label={hover}>
        <span>{StateMapping[cell.state]}</span>
      </Tooltip>
    )
  }

  return StateMapping[cell.state]
}

export default BankAuthState
